import React, { useEffect } from 'react'
import {motion} from "framer-motion"
import '../components/Styles/home.css'
import {Helmet}from"react-helmet";
import qu1 from '../images/qu1.png';
import a from '../images/a.png';
import b from '../images/b.png';
import c from '../images/c.png';
import d from '../images/d.png';
import e from '../images/e.png';
import f from '../images/f.png';
import g from '../images/g.png';
import hair from '../images/hair.png';
import glas from '../images/glas.png';
import bug from '../images/bug.png';
import contai from '../images/contai.png';
import AOS from 'aos';
import 'aos/dist/aos.css';

 const Home =()=> {
  useEffect(()=>{
    AOS.init();
  })
  return (
    <div>
      <Helmet>
      
      <title>Engineering, Interior Remodeling & Construction Company - Jayco Construction</title>
      <meta name="description" content="We exist to build great things! Jayco Construction is a leading engineering construction company provides General Engineering, Interior Remodeling & Construction services."/>
      < meta name="viewport" content="width=device-width, initial-scale=1.0"/>
      <meta charset="UTF-8"/>
      
      </Helmet>
    <section style={{background:"#F5F5F5"}} className='main_sec'>
      <div className='hd'>
        <div className='h_top_row'>
          
            <div className='top__col'>
               <h1>Everyday Tools. <br />
              <span style={{color:"#4CAF50"}}>Elevated.</span> </h1>
         
               <p>Smarter solutions for grooming, cleaning & comfort
               — designed for real life.</p>
         
               <button style={{background:"black",color:"white"}}>< i class='bx  bx-cart'  ></i> Shop Now</button> <button>Free Shipping Over $49</button>
            </div>

            <div className='top__col'>
               <img src={qu1} alt="" />
               </div>
        </div>
        </div>
    </section>
      <br /><br />
    <section>
      <div className='sec_2'>
        <button>FEATURED COLLECTION</button>
       
        <h2>Bestselling Favorites</h2>
        <p>Meet the tools our customers can't stop talking about.</p>
        <br />
        <button style={{background:"black",color:"white",borderRadius:"20px"}}>QuickClean Roller</button> <button style={{borderRadius:"20px"}}>Smart Scalp Massager</button>  <button style={{borderRadius:"20px"}}>DeepClean Sweeper</button>
         <br /><br />
         <div className='sec2_row'>
          <div style={{background:"#F5F5F5"}} className='sec2_col'>
               <img src={qu1} alt="" /> 
          </div>
       
       
          <div className='sec2_col' style={{textAlign:"left"}}>
          <i class="ri-checkbox-blank-circle-fill"></i>
             <h3>QuickClean Roller</h3>
             <h5>Pet hair gone in seconds</h5>
             <p>Our QuickClean Roller makes pet hair removal effortless. The 19.5cm roller head
with specialized grip surface picks up hair from furniture, clothing and car interiors
without the need for refills or electricity.</p>
<h5>Size: 19.5cm × 5.5cm × 21cm</h5>
<button>Add to Cart</button>
          </div>
         </div>

<br />

         <div className='sec2_row2'>
          <div style={{background:"#F5F5F5"}} className='sec_col2'>
                  
                  <img src={a} alt="" />
                  <br /> <br />
                <div style={{width:"100%",textAlign:"left"}}>
                <i class="ri-checkbox-blank-circle-fill"></i>
                <h3>QuickClean Roller</h3>
                  <p>Pet hair gone in seconds</p>
                  <button>View</button> <button style={{marginLeft:"40%",border:"none"}}>+ More</button>
                </div>
                
          </div>
          <div style={{background:"#F5F5F5"}} className='sec_col2'>
                  
                  <img src={b} alt="" />
                  <br /> <br />
                <div style={{width:"100%",textAlign:"left"}}>
                <i class="ri-checkbox-blank-circle-fill"></i>
                <h3>Smart Scalp Massager</h3>
                  <p>Relax, refresh, repeat</p>
                  <button>View</button> <button style={{marginLeft:"40%",border:"none"}}>+ More</button>
                </div>
                
          </div>
          <div style={{background:"#F5F5F5"}} className='sec_col2'>
                  
                  <img src={c} alt="" />
                  <br /> <br />
                <div style={{width:"100%",textAlign:"left"}}>
                   <i class="ri-checkbox-blank-circle-fill"></i>
                <h3>DeepClean Sweeper</h3>
                  <p>For sofas, rugs & car seats</p>
                  <button>View</button> <button style={{marginLeft:"40%",border:"none"}}>+ More</button>
                </div>
                
          </div>
          <div style={{background:"#F5F5F5"}} className='sec_col2'>
                  
                  <img src={hair} alt="" />
                  <br /> <br />
                <div style={{width:"100%",textAlign:"left"}}>
                   <i class="ri-checkbox-blank-circle-fill"></i>
                <h3>Pet hair lint rollers</h3>
                  <p>Effortless pet hair removal</p>
                  <button>View</button> <button style={{marginLeft:"40%",border:"none"}}>+ More</button>
                </div>
                
          </div>
         </div>
         <br />
         <div className='sec2_row2'>
          <div style={{background:"#F5F5F5"}} className='sec_col2'>
                  
                  <img src={glas} alt="" />
                  <br /> <br />
                <div style={{width:"100%",textAlign:"left"}}>
                <i class="ri-checkbox-blank-circle-fill"></i>
                <h3>Household Containers</h3>
                  <p>Sustainable food storage</p>
                  <button>View</button> <button style={{marginLeft:"40%",border:"none"}}>+ More</button>
                </div>
                
          </div>
          <div style={{background:"#F5F5F5"}} className='sec_col2'>
                  
                  <img src={contai} alt="" />
                  <br /> <br />
                <div style={{width:"100%",textAlign:"left"}}>
                <i class="ri-checkbox-blank-circle-fill"></i>
                <h3>Non-electric Food Blenders</h3>
                  <p>Blend without electricity</p>
                  <button>View</button> <button style={{marginLeft:"40%",border:"none"}}>+ More</button>
                </div>
                
          </div>
          <div style={{background:"#F5F5F5"}} className='sec_col2'>
                  
                  <img src={bug} alt="" />
                  <br /> <br />
                <div style={{width:"100%",textAlign:"left"}}>
                   <i class="ri-checkbox-blank-circle-fill"></i>
                <h3>Water Tumbler</h3>
                  <p>Keep drinks at ideal temperature</p>
                  <button>View</button> <button style={{marginLeft:"40%",border:"none"}}>+ More</button>
                </div>
                
          </div>
          <div style={{background:"#F5F5F5",visibility:"hidden"}} className='sec_col2'>
                  
                  <img src={hair} alt="" />
                  <br /> <br />
                <div style={{width:"100%",textAlign:"left"}}>
                   <i class="ri-checkbox-blank-circle-fill"></i>
                <h3>Non-electric Food Blenders</h3>
                  <p>Blend without electricity</p>
                  <button>View</button> <button style={{marginLeft:"40%",border:"none"}}>+ More</button>
                </div>
                
          </div>
         </div>
                   <button style={{background:"white"}}>View All Products  
 
                   </button>
       </div>
<br /><br />
    </section>
  <section style={{background:"#F5F5F5"}}  className='sec3'>
    <div className='sec3b'>
        <p style={{marginTop:"2%"}}>WHY LAVOUCH?</p>
        <h2>Tools that do more. For less.</h2>
        <br /><br />
        <div className='minim'>
          <div className='row3a'>
            <div className='col3a'>
              
              <h2>Built for real-life messes</h2>
              <p>Our products are designed to handle the
                toughest cleaning challenges in your everyday life.</p>
            </div>
            <div className='col3a'>
              <h2>Built for real-life messes</h2>
              <p>Our products are designed to handle the
                toughest cleaning challenges in your everyday life.</p>
            </div>

          </div>

          <div style={{marginTop:"2%"}} className='row3a'>
            <div className='col3a'>
              <h2>Built for real-life messes</h2>
              <p>Our products are designed to handle the
                toughest cleaning challenges in your everyday life.</p>
            </div>
            <div className='col3a'>
              <h2>Built for real-life messes</h2>
              <p>Our products are designed to handle the
                toughest cleaning challenges in your everyday life.</p>
            </div>

          </div>
        </div>
    </div>
  </section>
<br /><br /><br />
  <section className=''>
   <div className='sec4'>
     <p>REVIEWS / SOCIAL PROOF</p>
     <h2>❤ Loved by thousands of happy customers</h2>
     <br /><br />
     <div className='rowsec4'>
      <div className='colsec4'>
      
< i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
< i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
< i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
< i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
< i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
       <h3>QuickClean Roller</h3>
       <p>"This brush removed every bit of fur from
       my couch!"</p>
       <h5>— Sarah K.</h5>  
      </div>
      <div className='colsec4'>
      < i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
< i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
< i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
< i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
< i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
       <h3>Smart Scalp Massager</h3>
       <p>"So much easier than vacuums I use it
       every day."</p>
       <h5>— Michael T.</h5>  
      </div>
      <div className='colsec4'>
      < i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
< i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
< i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
< i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
< i style={{color:"#F6BE00"}} class="ri-star-fill"></i>
       <h3>DeepClean Sweeper</h3>
       <p>"Best investment I've made for my home
       this year!"</p>
       <h5>— Jessica R.</h5>  
      </div>
     </div>
<br />
     <h4 >See More Reviews</h4>
   </div>
  </section>
<br /><br /><br />

<section>
  <div className='lst_sec'>
<p>Join the #LavouchLife</p>
<h2>Share your Lavouch experience</h2>
<p>Follow us on Instagram @lavouchlife <br />
Tag us to get featured — we love seeing your results.</p>
<br /><br />
<div className='lst_row'>
<div className='lst_col'>
  <img src={g} alt="" />
</div>
<div className='lst_col'>
  <img src={d} alt="" />
</div>
<div className='lst_col'>
  <img src={e} alt="" />
</div>
<div className='lst_col'>
  <img src={f} alt="" />
</div>
</div>
  </div>
</section>
<br /><br />
    </div>
  )
}
export default Home;